import type { RequirementCompletion } from '../types';

export interface ParsedTeacherClearance {
  id: string;
  partnerId: string;
  teacherId: string;
  cleared: boolean;
  requirementStatuses: RequirementCompletion[];
}

export function parsePartnerTeacherClearance(
  id: string,
  data: Record<string, unknown>
): ParsedTeacherClearance {
  const rawStatuses = data.requirementStatuses;
  const requirementStatuses = rawStatuses && typeof rawStatuses === 'object' && !Array.isArray(rawStatuses)
    ? Object.entries(rawStatuses as Record<string, unknown>).map(([requirementId, raw]) => {
        const value = raw && typeof raw === 'object' ? raw as Record<string, unknown> : {};
        return {
          ...value,
          requirementId: String(value.requirementId || requirementId),
          requirementVersion: Number(value.requirementVersion || 1),
          status: String(value.status || 'not_started'),
        } as RequirementCompletion;
      })
    : [];

  return {
    id,
    partnerId: String(data.partnerId || ''),
    teacherId: String(data.teacherId || id),
    cleared: data.cleared === true,
    requirementStatuses,
  };
}

export function flattenLegacyClearanceItems(
  documents: Array<{ id: string; data: Record<string, unknown> }>
): Array<Record<string, unknown>> {
  return documents.flatMap(document => {
    const items = Array.isArray(document.data.items) ? document.data.items : [];
    return items.map((item, index) => ({
      ...(item && typeof item === 'object' ? item as Record<string, unknown> : {}),
      id: String((item as any)?.id || `${document.id}-${index}`),
      schoolId: String(document.data.schoolId || document.id),
      historical: true,
    }));
  });
}
